// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-update-task-priority.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm(
  $task_id: uuid!
  $priority: tasks_priorities_enum!
) {
  update_tasks_tasks_by_pk(
    pk_columns: { id: $task_id }
    _set: { priority: $priority }
  ) {
    id
  }
}

`